import { render, staticRenderFns } from "./ModalDetalheAnalise.vue?vue&type=template&id=36763a20&lang=pug"
import script from "./ModalDetalheAnalise.vue?vue&type=script&lang=js"
export * from "./ModalDetalheAnalise.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalheAnalise.vue?vue&type=style&index=0&id=36763a20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports